

/**
 * @name ArtistStatsController
 * @description Controller for shop stats
 * @param {type} $scope Description
 * @param {type} $interval Description
 * @param {type} Appointments Description
 * @param {type} moment The Moment library
 * @param {type} STATUS_IDS The appointment status IDs constant
 */
function ArtistStatsController(
  $scope,
  $interval,
  Appointments,
  moment,
  STATUS_IDS
) {
  let vm = this;
  vm.$onInit = function() {
    vm.updateFilter = updateFilter;
    vm.intervalSelect = 'today';
    vm.period = {};
    vm.updating = false;
    vm.stats = {};
    updateFilter();
  };

  let statsTimer;
  statsTimer = $interval(update, 60000);

  // Called to Reset Data on Logout
  $scope.$on('clear-data', function() {
    $interval.cancel(statsTimer);
  });

  /**
   * @name update
   * @description Function to update stats
   */
  function update() {
    let start = vm.period.firstDay;
    let end = vm.period.lastDay;
    let search = false;
    let timestamp = null;

    Appointments.get(search, start, end, timestamp)
    .then(function(appointments) {
      let revenueTotal = 0;
      let projectTotal = 0;
      let tipTotal = 0;

      for (let i = 0; i < appointments.length; i++) {
        let current = appointments[i];
        if (current.current_status === STATUS_IDS.completed) {
          projectTotal++;
          revenueTotal += current.price;
          current.paymentData.tipTotal ? tipTotal
          += current.paymentData.tipTotal : tipTotal + 0;
        }
      }
      vm.stats.appointments = projectTotal;
      vm.stats.revenue = revenueTotal;
      vm.stats.tips = tipTotal;
      vm.stats.average = (projectTotal ? revenueTotal / projectTotal : 0);
      vm.updating = false;
    });
  }

  /**
   * @name setIntervals
   * @description Function to set the intervals of the quick stats shelf.
   */
  function updateFilter() {
    vm.updating = true;
    vm.period = {};

    if (vm.intervalSelect === 'yesterday') {
      vm.period.firstDay = moment().subtract(1, 'days').startOf('day');
      vm.period.lastDay = moment().subtract(1, 'days').endOf('day');
    } else if (vm.intervalSelect === 'thisWeek') {
      vm.period.firstDay = moment().startOf('week');
      vm.period.lastDay = moment().endOf('week');
    } else if (vm.intervalSelect === 'lastWeek') {
      vm.period.firstDay = moment().subtract(1, 'weeks').startOf('week');
      vm.period.lastDay = moment().subtract(1, 'weeks').endOf('week');
    } else if (vm.intervalSelect === 'thisMonth') {
      vm.period.firstDay = moment().startOf('month');
      vm.period.lastDay = moment().endOf('month');
    } else if (vm.intervalSelect === 'lastMonth') {
      vm.period.firstDay = moment().subtract(1, 'months').startOf('month');
      vm.period.lastDay = moment().subtract(1, 'months').endOf('month');
    } else if (vm.intervalSelect === 'thisQuarter') {
      vm.period.firstDay = moment().startOf('quarter');
      vm.period.lastDay = moment().endOf('quarter');
    } else if (vm.intervalSelect === 'lastQuarter') {
      vm.period.firstDay = moment().subtract(1, 'quarters').startOf('quarter');
      vm.period.lastDay = moment().subtract(1, 'quarters').endOf('quarter');
    } else if (vm.intervalSelect === 'thisYear') {
      vm.period.firstDay = moment().startOf('year');
      vm.period.lastDay = moment().endOf('year');
    } else if (vm.intervalSelect === 'lastYear') {
      vm.period.firstDay = moment().subtract(1, 'years').startOf('year');
      vm.period.lastDay = moment().subtract(1, 'years').endOf('year');
    } else {
      vm.period.firstDay = moment().startOf('day');
      vm.period.lastDay = moment().endOf('day');
    }
    update();
  }
}

angular
  .module('inkfinder')
  .controller('ArtistStatsController', ArtistStatsController);



// WEBPACK FOOTER //
// ./components/artists/artist/stats/artist-stats.controller.js